import { createContext, useContext, useRef } from "react";

const PendingInputContext = createContext();

/// This context is used by TagInputField to store the pending input value that has not yet been applied to the search model. 
/// This allows us to apply the pending input when the user clicks the search button, 
/// ensuring that any input that has not yet been applied to the search model is included in the search results.
export const PendingInputProvider = ({ children }) => {
    const valueRef = useRef({});
    return (
        <PendingInputContext.Provider value={valueRef}>
            {children}
        </PendingInputContext.Provider>
    );
};

export const usePendingInput = () => useContext(PendingInputContext);
